
//competencias del empleado
export const LOADING_EMPLOYEE_COMPETENCY = "LOADING_EMPLOYEE_COMPETENCY";
export const SAVE_LOADING_EMPLOYEE_COMPETENCY = "SAVE_LOADING_EMPLOYEE_COMPETENCY";
export const GET_EMPLOYEE_COMPETENCY = "GET_EMPLOYEE_COMPETENCY";
export const FORM_FAIL_EMPLOYEE_COMPETENCY = "FORM_FAIL_EMPLOYEE_COMPETENCY";
export const EMPLOYEE_COMPETENCY_FAIL = "EMPLOYEE_COMPETENCY_FAIL";
export const LOADING_EMPLOYEE_COMPETENCY_BY_ID = "LOADING_EMPLOYEE_COMPETENCY_BY_ID";
export const GET_EMPLOYEE_COMPETENCY_BY_ID = "GET_EMPLOYEE_COMPETENCY_BY_ID";

//competencias del jefe
export const LOADING_BOSS_COMPETENCY = "LOADING_BOSS_COMPETENCY";
export const SAVE_LOADING_BOSS_COMPETENCY = "SAVE_LOADING_BOSS_COMPETENCY";
export const GET_BOSS_COMPETENCY = "GET_BOSS_COMPETENCY";
export const FORM_FAIL_BOSS_COMPETENCY = "FORM_FAIL_BOSS_COMPETENCY";
export const BOSS_COMPETENCY_FAIL = "BOSS_COMPETENCY_FAIL";
export const LOADING_BOSS_COMPETENCY_BY_ID = "LOADING_BOSS_COMPETENCY_BY_ID";
export const GET_BOSS_COMPETENCY_BY_ID = "GET_BOSS_COMPETENCY_BY_ID";

